<template>
  <div class="quit-info">
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <img src="@/assets/common/user.png" class="user">
        <span class="user-name">
          {{ userAccount }}
        </span>
      </span>
      <el-dropdown-menu slot="dropdown" class="drop-item">
        <el-dropdown-item command="1">
          <img src="@/assets/common/exit.png">
          <span>{{ $t('exit.title') }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'QuitInfo',
  // data() {
  //   return {
  //     userName: ''
  //   }
  // },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    userAccount() {
      // console.log('userAccount', this.userInfo.loginNameSensitization || this.userInfo.emailSensitization || this.userInfo.phoneNumberSensitization || this.userInfo.usernameSensitization)
      return this.userInfo.loginNameSensitization || this.userInfo.emailSensitization || this.userInfo.phoneNumberSensitization || this.userInfo.usernameSensitization
    }
  },
  // watch: {
  //   'userInfo.usernameSensitization': {
  //     handler(n, o) {
  //       this.userName = n
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    handleCommand(command) {
      if (command === '1') {
        this.logout()
      }
    },
    logout() {
      this.$confirm(this.$t('exit.message'), this.$t('standard.tips'), {
        confirmButtonText: this.$t('standard.define'),
        cancelButtonText: this.$t('standard.cancel'),
        cancelButtonClass: 'btn-custom-cancel',
        showClose: false,
        customClass: 'confirm-warning'
      }).then(async() => {
        window.iuop.exit = true
        await this.$store.dispatch('user/logout')
        this.$message({
          type: 'success',
          message: this.$t('exit.success')
        })
        // const loginPage = window.localStorage.getItem('loginPage')
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
        // if (loginPage === '2') {
        //   this.$router.push(`/old-login?redirect=${this.$route.fullPath}`)
        // } else {
        // }
      }).catch((error) => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.quit-info {
  cursor: pointer;
  .user {
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }
  .user-name {
    display: inline-block;
    vertical-align: middle;
    color: $color01;
  }
}
</style>
